import { withInstall as t } from "../../utils/with-install.js";
import o from "./select.vue.js";
/* empty css            */
const p = t(o);
export {
  p as ApSelect,
  p as default
};
